// src/utils/domain.ts
const MULTI_PART_TLDS = new Set([
  'co.uk','org.uk','gov.uk','ac.uk',
  'com.au','net.au','org.au',
  'co.in','gov.in','org.in',
  'co.nz','gov.nz','org.nz'
]);

function toHost(input: string): string {
  let s = (input || '').trim().toLowerCase();
  if (!s) return s;
  if (!/^https?:\/\//.test(s)) s = `https://${s}`;
  try {
    const u = new URL(s);
    return (u.host || s).split(':')[0];
  } catch {
    return s.split('/')[0].split(':')[0];
  }
}

export function toRootDomain(input: string): string {
  const host = toHost(input);
  const parts = host.split('.').filter(Boolean);
  if (parts.length <= 2) return host;

  const last2 = parts.slice(-2).join('.');
  const last3 = parts.slice(-3).join('.');
  if (MULTI_PART_TLDS.has(last2) && parts.length >= 3) {
    // e.g. foo.bar.co.uk -> bar.co.uk
    return parts.slice(-3).join('.');
  }
  // default: take last 2 labels (e.g., links-1.govdelivery.com -> govdelivery.com)
  return last2;
}
